"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class SubscriptionsService {
    /**
     * Get list of subscriptions
     * @param language Filter subscriptions by language (name of the language)
     * @returns Subscription
     * @throws ApiError
     */
    static subscriptionsList(language) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/subscriptions/',
            query: {
                'language': language,
            },
        });
    }
}
exports.SubscriptionsService = SubscriptionsService;
